import { Capacitor } from "@capacitor/core";

/** True when running inside the Capacitor native shell (iOS / Android), false on web. */
export const isNative = (): boolean => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const nativePlatform = (): "ios" | "android" | "web" => {
  try {
    const p = Capacitor.getPlatform();
    if (p === "ios" || p === "android") return p;
  } catch (_) { /* noop */ }
  return "web";
};
